export default "__VITE_PUBLIC_ASSET__dab5342b__"